import revive_payload_client_4sVQNw7RlN from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import supabase_client_2ruDq4uEtU from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/@nuxtjs/supabase/dist/runtime/plugins/supabase.client.js";
import payload_client_yVLowv6hDl from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/Users/rayyach/Desktop/sites/saveAtCost.co/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import auth_redirect_bWtzICY6fh from "/Users/rayyach/Desktop/sites/saveAtCost.co/node_modules/@nuxtjs/supabase/dist/runtime/plugins/auth-redirect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  supabase_client_2ruDq4uEtU,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  auth_redirect_bWtzICY6fh
]